import { createSlice } from "@reduxjs/toolkit";

export type TablePagination = {
  tabs: {
    tab0: { current: number; size: number };
    tab1: { current: number; size: number };
    tab2: { current: number; size: number };
    tab3: { current: number; size: number };
    tab4: { current: number; size: number };
    tab5: { current: number; size: number };
  };
};

/* Five, which is the first of the sizes the pager actually offers. It was
   six — a number absent from `pageSizeOptions` — so the control opened with a
   "6 / page" row that existed only because it was selected, and no amount of
   paging could return to it once you left. */
const initialState: TablePagination = {
  tabs: {
    tab0: {
      current: 1,
      size: 5,
    },
    tab1: {
      current: 1,
      size: 5,
    },
    tab2: {
      current: 1,
      size: 5,
    },
    tab3: {
      current: 1,
      size: 5,
    },
    tab4: {
      current: 1,
      size: 5,
    },
    tab5: {
      current: 1,
      size: 5,
    },
  },
};

const slice = createSlice({
  name: "tablepagination",
  initialState,
  reducers: {
    setTablePagination: (state: TablePagination, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setTablePagination } = slice.actions;

export default slice.reducer;
